import React from "react";
import heroImage from "../assets/developer.svg";
import { BiRightArrowAlt } from "react-icons/bi";
import { Link } from "react-scroll";

const Home = () => {
  

  return (
    <div name="home" className=" py-20 md:py-16 w-full">
      <div className=" mx-auto flex flex-col items-center justify-between h-[100svh] px-4 md:flex-row relative">
        <div className="flex flex-col justify-center h-full">
          <h1 className="text-3xl sm:text-7xl font-bold text-white">
            <span className="text-4xl sm:text-8xl font-outline-xs text-transparent">
              Creative
            </span>{" "}
            Developer
          </h1>
          <div className="magnetButton max-w-fit">
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group cursor-pointer text-white w-fit px-6 py-3 my-3 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 "
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-500 ml-1">
                <BiRightArrowAlt size={25} />
              </span>
            </Link>
          </div>
        </div>
        <div className="w-2/3 rounded-2xl px-4 overflow-hidden">
          <img id="heroImage" src={heroImage} alt="profile" className="heroImage max-h-fit" />
        </div>
      </div>
    </div>
  );
};

export default Home;
